import BaseService from './BaseService'

class DocumentService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }

  upload = (params,file) =>
    this.requests.post(
      `/upload?locationId=${params.locationId}&contactId=${params.contactId}&customFieldId=${params.customFieldId}&folderName=${params.folderName}`,
      file
    )
}

const instance = new DocumentService(BaseService.servicesConfig.Documents)

export default instance
